import React from "react";
import "./styles.css";

const Technologies = () => {
  return (
    <div className="tech-container">
      <h5>Some technologies that i use</h5>
      <div className="tech">
        <img
          className="tech-img"
          src="https://i.imgur.com/7VpD08I.png"
          alt="CSS"
        />
        <img
          className="tech-img js"
          src="https://i.imgur.com/1HzmBfL.png"
          alt="JS"
        />
        <img
          className="tech-img"
          src="https://i.imgur.com/readXt5.png"
          alt="HTML5"
        />
        <img
          className="tech-img"
          src="https://i.imgur.com/5MsaJ91.png"
          alt="Boostrap"
        />
        <img
          className="tech-img"
          src="https://i.imgur.com/oh3LamL.png"
          alt="Sass"
        />
        <img
          className="tech-img"
          src="https://i.imgur.com/YpHvAsf.png"
          alt="React JS"
        />
        <img
          className="tech-img"
          src="https://i.imgur.com/fZ5mchL.png"
          alt="Redux"
        />
        <img
          className="tech-img"
          src="https://i.imgur.com/DRJVNGP.png"
          alt="Node JS"
        />
        <img
          className="tech-img"
          src="https://i.imgur.com/0A0HoHg.png"
          alt="Firebase"
        />
        <img
          className="tech-img js"
          src="https://i.imgur.com/n45cOtX.png"
          alt="Mongo DB"
        />
      </div>
    </div>
  );
};

export default Technologies;
